/** Legal 500 CRM industry sectors; also used by Address Book company editing. */
export const COMPANY_INDUSTRY_SECTORS = [
    "Agribusiness",
    "Art & Culture",
    "Banking Services",
    "Charities & Non-Profit",
    "Consumer Goods, Food & Retail",
    "Education",
    "Energy, Power & Natural Resources",
    "Government & Public Sector",
    "Healthcare, Pharmaceuticals & Life Sciences",
    "Hospitality, Gaming, Sport & Leisure",
    "Insurance Services",
    "Investment Services",
    "Law Firms & Legal Services",
    "Manufacturing & Industrials",
    "Media & Telecommunications",
    "Other",
    "Private Client",
    "Professional Businesses & Services",
    "Projects & Infrastructure",
    "Real Estate & Construction",
    "Tax & Accounting Services",
    "Technology",
    "Transport",
];
// Both enums below are enforced only on the single-company staff form
// (CreateMasterCompanySchema, services/users-api/src/schemas/websiteCompanies.ts); the bulk CSV
// import (MasterCompanyInputSchema) stores whatever free text the file carries in these columns.
/** Master-company additions share the CRM sectors; leaving the field blank is supported. */
export const MASTER_COMPANY_INDUSTRY_SECTORS = COMPANY_INDUSTRY_SECTORS;
/** Prepared master-company bands, plus a band for smaller companies added by staff. */
export const MASTER_COMPANY_EMPLOYEE_BANDS = [
    "1-999",
    "1,000-4,999",
    "5,000-9,999",
    "10,000+",
];
export const COMPANY_WEBSITE_ERROR = "Enter a domain (example.com) or an HTTP(S) URL, without credentials, a port, a query string or a fragment.";
/**
 * Validate website syntax and store a bare domain, or a domain plus path, as used by the
 * prepared company list -- some entries are a specific page within a larger organisation's
 * domain (an institute's page on a university site, say), not that domain's homepage.
 */
export function normaliseCompanyWebsite(value) {
    const input = value?.trim();
    if (!input)
        return null;
    if (!/^(?:https?:\/\/)?[^/:?#@\\\s]+(?:\/[^?#\\\s]*)?$/iu.test(input))
        throw new Error(COMPANY_WEBSITE_ERROR);
    let url;
    try {
        url = new URL(/^https?:\/\//i.test(input) ? input : `https://${input}`);
    }
    catch {
        throw new Error(COMPANY_WEBSITE_ERROR);
    }
    const domain = url.hostname;
    const labels = domain.split(".");
    if (!/^https?:$/u.test(url.protocol) ||
        url.username ||
        url.password ||
        url.port ||
        url.search ||
        url.hash ||
        /[?#]/u.test(input) ||
        domain.length > 253 ||
        labels.length < 2 ||
        labels.some(label => !/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/u.test(label)) ||
        !/[a-z]/u.test(labels[labels.length - 1]))
        throw new Error(COMPANY_WEBSITE_ERROR);
    // The path keeps its case (paths are case-sensitive). Repeated slashes are collapsed to
    // one and every trailing slash is stripped, so the same page dedupes to one stored value
    // regardless of how many slashes it was typed or pasted with -- re-normalising the result
    // of normaliseCompanyWebsite must be a no-op, or an already-normalised value re-submitted
    // through this function (e.g. a CSV row vs. a form re-save) drifts and duplicates the
    // catalogue row.
    const collapsedPath = url.pathname.replace(/\/{2,}/gu, "/");
    const path = collapsedPath === "/" ? "" : collapsedPath.replace(/\/+$/u, "");
    return domain + path;
}
//# sourceMappingURL=company-fields.js.map